import {FieldError, useFormContext} from 'react-hook-form';
import lodash from 'lodash';

type PossibleArrayOrObject = Record<string, unknown> | Array<unknown>;

/**
 * The name is a dot seperated string that represents the path to the field in the form data.
 */
const getFormError = (
    name: string,
    errors: PossibleArrayOrObject,
): FieldError | undefined => {
    const [segment, ...remainingSegments] = name.split('.');

    if (errors === undefined) {
        return undefined;
    }

    if (Array.isArray(errors)) {
        if (remainingSegments.length === 0) {
            return errors[Number(segment)] as FieldError;
        }

        return getFormError(
            remainingSegments.join('.'),
            errors[Number(segment)] as PossibleArrayOrObject,
        );
    }

    if (lodash.isObject(errors)) {
        if (remainingSegments.length === 0) {
            return errors[segment] as FieldError;
        }

        return getFormError(
            remainingSegments.join('.'),
            errors[segment] as PossibleArrayOrObject,
        );
    }
    throw new TypeError('Invalid errors object, should be Array or Object.');
};
export const mockGetFormError = getFormError;

const useFormError = (
    name?: string | undefined,
    override?: FieldError | undefined,
): FieldError | undefined => {
    const {
        formState: {errors},
    } = useFormContext();

    if (!name) return undefined;

    // TODO: This is here so we can continue to define errors manually e.g. for creating visual examples of what an error looks like in storybook.
    // In a real page, we shouldn't really need to manually populate the error prop of a field because this is handled by React Hook Forms.
    // Can remove 'override' in the future.
    if (override) return override;

    if (!errors) return undefined;

    return getFormError(name, errors);
};

export default useFormError;
